import { h } from 'vue';
import { DownloadOutlined } from '@ant-design/icons-vue';
import { Button } from 'ant-design-vue';

/**
 * Renders a download button for a file item
 * @param {Object|null} fileItem - The file item to download
 * @param {Function} downloadHandler - Function to handle the download action
 * @returns {Object|null} - Vue render function result or null if no file item
 */
export function renderDownloadButton(fileItem, downloadHandler) {
  if (!fileItem) return null;

  return h(
    Button,
    {
      type: 'link',
      onClick: () => downloadHandler(fileItem[0].storage_location),
    },
    {
      default: () =>
        h(DownloadOutlined, {
          style: 'font-size: 24px;',
        }),
    },
  );
}
